import axios from 'axios'
import { APIHOTS as API } from '@/API.js'

const apiClient = axios.create({
  baseURL: `${API}/hotspots`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: localStorage.getItem('argusblack.token')
  }
})

// Actualización del token de autorización
document.addEventListener('actualizar:token', function(e) {
  apiClient.defaults.headers['Authorization'] = e.detail
})

// Eliminación del token de autorización
document.addEventListener('eliminar:token', function() {
  apiClient.defaults.headers['Authorization'] = null
})

export default {
  actualizar(hotspot) {
    return apiClient.patch(`/${hotspot.id}`, hotspot)
  },

  cantidadActivos() {
    return apiClient.get('/cantidad-activos')
  },

  cantidadInactivos() {
    return apiClient.get('/cantidad-inactivos')
  },

  eliminar(idHotspot) {
    return apiClient.delete(`/${idHotspot}`)
  },

  guardar(hotspot) {
    return apiClient.post('', hotspot)
  },

  hotspotJSON(idHotspot,params) {
    params = params || {}
    return apiClient.get(`${idHotspot}.json`,{params:params})
  },

  hotspotsJSON(params) {
    params = params || {}
    return apiClient.get(`${API}/hotspots.json`, { params: params })
  },

  resincronizar(idHotspot) {
    return apiClient.post(`${idHotspot}/resincronizar`)
  }
}
